import MemberGetMember from './MemberGetMember';

export default MemberGetMember;
